<template>
  <main-content-layout :title="$gettext('INVOICE_SETTLEMENT')">
    <q-layout data-testid="report-manager" class="q-pa-lg">

      <div class="buttons-area">
        <div class="index-table tw-flex tw-items-center tw-gap-2">
          <invoice-situation
            v-for="situationName in displayedSituations"
            :key="situationName"
            :text="situationMapSettlement[situationName].text"
            :color="situationMapSettlement[situationName].color"
            @clickAction="filterInvoice"
          />
        </div>
        <div class="right-buttons">
          <service-request-invoice-settlement-exemption
            v-if="exemptionModal.show"
            ref="modalExemption"
            :show="exemptionModal.show"
            :label="exemptionModal.label"
            :consumerUnit="consumerUnit"
            :protocol="protocol"
            :maximized="false"
            @input="(val) => closeInvoiceSettlementModal()"
          />
          <service-request-invoice-settlement-cancellation
            v-if="cancellationModal.show"
            ref="modalCancellation"
            :show="cancellationModal.show"
            :label="cancellationModal.label"
            :consumerUnit="consumerUnit"
            :protocol="protocol"
            :maximized="false"
            @input="(val) => closeInvoiceSettlementModal()"
          />
          <service-request-invoice-settlement-search
            v-if="searchModal.show"
            ref="modalSearch"
            :show="searchModal.show"
            :label="searchModal.label"
            @input="(val) => searchModal.show = false"
            @search-click="applySearchFilter"
          />
        </div>
      </div>
      <div v-if="activeFilters.length" class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 q-mb-md q-mt-sm">
        <q-chip
          v-for="filter in activeFilters"
          :key="filter.key"
          removable
          color="grey-4"
          text-color="black"
          @remove="removeFilter(filter.key)"
        >
          {{ filter.label }}
        </q-chip>
        <q-btn
          flat
          dense
          size="sm"
          color="grey-7"
          :label="$gettext('CLEAR_ALL_FILTERS')"
          @click="clearAllFilters"
        />
      </div>
      <jt-data-table
        ref="datatable"
        v-if="datatable && datatableModelFilter"
        :api-mode="false"
        :data="datatableModelFilter"
        :buttons="datatable.buttons"
        :fields="datatable.columns"
        noneselect
        :is-paginated="false"
        @action-button="actionButton"
      >
      <template #header="{props}">
          <q-tr :props="props" class="table-header">
            <q-td
              v-for="col in props.cols"
              class="text-center"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-td>
            <q-td class="width-5 text-center"> </q-td>
          </q-tr>
        </template>
        <template #body="{ props }">
          <q-tr class="text-left">
            <q-td
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
              class="text-color"
            >
            <div v-if="col.field == 'invoice'">
              <span class="font-size-field">
                  {{ $toLocaleStringBr(props.row["invoice"]) }}
                </span>
            </div>
            <div v-else-if="col.field == 'date'">
                <strong class="font-size-date">
                  {{ moment(
                      props.row["date"],
                      "DD/MM/YYYY HH:mm:ss"
                    ).format("DD/MM/YYYY") }}
                </strong>
                <br />
                <span>
                   {{ moment(
                      props.row["date"],
                      "DD/MM/YYYY HH:mm:ss"
                    ).format("HH:mm:ss") }}
                </span>
            </div>
              <div v-else-if="col.field == 'originalValue'">
              <span class="font-size-field">
                  {{ $toLocaleStringBr(props.row["originalValue"]) }}
                </span>
            </div>
            <div v-else-if="col.field == 'debt'">
              <span class="font-size-field">
                  {{ $toLocaleStringBr(props.row["debt"]) }}
                </span>
            </div>
            <div v-else-if="col.field == 'writeOff'">
              <span class="font-size-field">
                  {{ $toLocaleStringBr(props.row["writeOff"]) }}
                </span>
            </div>
            <div v-else-if="col.field == 'restitution'">
              <span class="font-size-field">
                  {{ $toLocaleStringBr(props.row["restitution"]) }}
                </span>
            </div>
            <span v-else-if="col.field == 'status'">
              <invoice-situation
              :text="getSettlementTypeByCode(props.row.status).text"
              :color="getSettlementTypeByCode(props.row.status).color"
                />
            </span>
            <span v-else>{{ col.value}}</span>
            </q-td>
            <q-td class="width-1 text-center nowrap">
              <span class="buttons-row">
                <span :key="0" class="btDetalhar">
                  <q-btn
                    flat
                    small
                    class="btAlterar-btn protocol-close"
                    color="primary"
                    @click="actionButtonDetail(props.row)"
                  >
                    <q-icon name="visibility" size="22px" />
                    <q-tooltip>
                      {{ $gettext("DETAIL") }}
                    </q-tooltip>
                  </q-btn>
                </span>
              </span>
              </q-td>
          </q-tr>
        </template>

      </jt-data-table>
      <service-request-invoice-settlement-detail
        v-if="modalDetailData.show"
        ref="modalDetailData"
        :show="modalDetailData.show"
        :id="modalDetailData.id"
        @input="() => { modalDetailData.show = false }"
      />
      <modal
        v-if="modalData.show"
        ref="detailModal"
        :show="modalData.show"
        v-bind="modalData"
        @input="closeDetailModal"
      />
    </q-layout>
  </main-content-layout>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtCrud } from 'jtech-webcomps'
import ServiceRequestInvoiceSettlementExemption from './ServiceRequestInvoiceSettlementExemption'
import ServiceRequestInvoiceSettlementController from './ServiceRequestInvoiceSettlementController'
import ServiceRequestController from '../../../../ServiceRequestController'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'
import moment from 'moment'
import { situationMapSettlement } from './situationInvoiceSettlement.config'
import InvoiceSituation from '../component/InvoiceSituation.vue'
import ServiceRequestInvoiceSettlementDetail from './ServiceRequestInvoiceSettlementDetail.vue'
import ServiceRequestInvoiceSettlementCancellation from './ServiceRequestInvoiceSettlementCancellation.vue'
import ServiceRequestInvoiceSettlementSearch from './ServiceRequestInvoiceSettlementSearch.vue'
import { settlementTypeMap } from '../component/settlementTypeMap.js'
import { invoiceSettlementType } from '../component/invoiceSettlementType.js'
const { modal } = JtCrud
import { invoiceSettlementStatus } from 'src/shared/inf-tabela-descricao/InvoiceSettlementStatus.enum.js'

const INTERFACE_NAMES = {
  LOAD_INVOICE_SETTLEMENT: 'serviceRequest.invoiceSettlement',
  LOAD_DATATABLE: 'serviceRequest.datatable',
  LOAD_DATATABLE_MODEL: 'serviceRequest.datatableModel',
  DETAIL: 'serviceRequest.detail'
}

const createErrorMessages = (vm) => ({
  LOAD_ERROR: vm.$gettext('ERROR_LOADING_DATA'),
  LOAD_DATATABLE_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE'),
  LOAD_DATATABLE_MODEL_ERROR: vm.$gettext('ERROR_LOADING_DATATABLE_MODEL'),
  ACTION_ERROR: vm.$gettext('ERROR_EXECUTING_ACTION'),
  DETAIL_ERROR: vm.$gettext('ERROR_DETAIL_RECORD')
})

@Component({
  name: 'ServiceRequestInvoiceSettlement',
  components: {
    ServiceRequestInvoiceSettlementCancellation,
    InvoiceSituation,
    ServiceRequestInvoiceSettlementExemption,
    MainContentLayout,
    modal,
    JtDataTable,
    ServiceRequestInvoiceSettlementDetail,
    ServiceRequestInvoiceSettlementSearch
  },
  props: {
    consumerUnit: {
      type: String,
      required: true
    },
    protocol: {
      type: String,
      required: true
    }
  }
})
class ServiceRequestInvoiceSettlement extends Vue {
  controller = ServiceRequestController.getInstance();
  serviceRequestInvoiceSettlementController =
    ServiceRequestInvoiceSettlementController.getInstance();

  static INTERFACES = INTERFACE_NAMES;

  filterText = 'ALL_ORDERS'

  searchFilters = {
    attendant: null,
    invoiceSettlementType: null,
    period: null
  }

  detailMode = false;
  data = []
  allSelected = null
  renderDetailModal = false;
  moment = moment;
  datatable = null;
  invoiceSettlementDetail = null;
  datatableModel = null;
  datatableModelFilter = []
  displayedSituations = [
    'ALL_ORDERS',
    'APPROVED',
    'UNDER_REVIEW',
    'DENIED'
  ];

  exemptionModal = {
    show: false,
    label: null
  };

  cancellationModal = {
    show: false,
    label: null
  }

  searchModal = {
    show: false,
    label: null
  };

  modalData = {
    show: false,
    detail: false,
    forms: null,
    label: null,
    params: null
  };

  modalDetailData = {
    show: false,
    id: null
  };

  ERROR_MESSAGES = null;

  created () {
    this.ERROR_MESSAGES = createErrorMessages(this)
  }

  closeDetailModal () {
    this.modalData.show = false
  }

  get invoiceSettlementStatus () {
    return invoiceSettlementStatus()
  }

  get activeFilters () {
    const filters = []
    const hasStatusFilter = this.filterText &&
      this.filterText !== 'ALL_ORDERS' &&
      this.situationMapSettlement[this.filterText]
    if (hasStatusFilter) {
      filters.push({
        key: 'status',
        label: `${this.$gettext('STATUS')}: ${this.$gettext(this.situationMapSettlement[this.filterText].text)}`
      })
    }
    if (this.searchFilters.attendant) {
      filters.push({
        key: 'attendant',
        label: `${this.$gettext('ATTENDANT')}: ${this.searchFilters.attendant}`
      })
    }
    if (this.searchFilters.invoiceSettlementType) {
      const typeVal = this.searchFilters.invoiceSettlementType
      let valueLabel = typeVal?.label || null
      if (!valueLabel) {
        const types = invoiceSettlementType()
        const match = Object.values(types).find(
          t => t.number == typeVal || t.number == typeVal?.number
        )
        valueLabel = match?.label || typeVal?.toString()
      }
      if (valueLabel) {
        filters.push({
          key: 'invoiceSettlementType',
          label: `${this.$gettext('TYPE')}: ${valueLabel}`
        })
      }
    }
    if (this.searchFilters.period?.inicial || this.searchFilters.period?.final) {
      const parts = [this.searchFilters.period.inicial, this.searchFilters.period.final]
        .filter(Boolean).join(' - ')
      filters.push({
        key: 'period',
        label: `${this.$gettext('PERIOD')}: ${parts}`
      })
    }
    return filters
  }

  filterInvoice (text) {
    if (text === this.filterText || text === 'ALL') {
      this.filterText = null
    } else {
      this.filterText = text
    }
    this._applyAllFilters()
  }

  applySearchFilter (dadosForm) {
    const period = dadosForm?.period
    this.searchFilters = {
      attendant: dadosForm?.attendant || null,
      invoiceSettlementType: dadosForm?.invoiceSettlementType || null,
      period: (period?.inicial || period?.final) ? period : null
    }
    this.searchModal.show = false
    this._applyAllFilters()
  }

  _applyAllFilters () {
    let filtered = this.datatableModel || []
    filtered = this._filterByStatus(filtered)
    filtered = this._filterByAttendant(filtered)
    filtered = this._filterBySettlementType(filtered)
    filtered = this._filterByPeriod(filtered)
    this.datatableModelFilter = filtered
  }

  _filterByStatus (items) {
    const filterMap = {
      DENIED: [this.invoiceSettlementStatus.DENIED.key],
      UNDER_REVIEW: [this.invoiceSettlementStatus.PENDING.key],
      APPROVED: [this.invoiceSettlementStatus.APPROVED.key, this.invoiceSettlementStatus.UPDATE.key]
    }
    if (!this.filterText || !filterMap[this.filterText]) return items
    return items.filter(item => filterMap[this.filterText].includes(item.status))
  }

  _filterByAttendant (items) {
    if (!this.searchFilters.attendant) return items
    const term = this.searchFilters.attendant.toString().toLowerCase()
    return items.filter(item => item.attendant?.toString().toLowerCase().includes(term))
  }

  _filterBySettlementType (items) {
    const typeVal = this.searchFilters.invoiceSettlementType
    if (!typeVal) return items
    return items.filter(item => {
      const itemType = item.invoiceSettlementType
      if (typeVal?.number !== undefined) {
        return itemType === typeVal.number || itemType?.number === typeVal.number
      }
      return itemType == typeVal
    })
  }

  _filterByPeriod (items) {
    const { inicial, final: finalDate } = this.searchFilters.period || {}
    if (!inicial && !finalDate) return items

    const toMonthIndex = (str) => {
      if (!str) return null
      const [mm, yyyy] = str.split('/')
      return parseInt(yyyy) * 12 + parseInt(mm)
    }

    const filterStart = toMonthIndex(inicial)
    const filterEnd = toMonthIndex(finalDate)

    return items.filter(item => {
      const rowStart = item.minYear * 12 + item.minMonth
      const rowEnd = item.maxYear * 12 + item.maxMonth
      if (filterStart && filterEnd) return rowStart <= filterEnd && rowEnd >= filterStart
      if (filterStart) return rowEnd >= filterStart
      if (filterEnd) return rowStart <= filterEnd
      return true
    })
  }

  removeFilter (key) {
    if (key === 'status') {
      this.filterText = null
    } else {
      this.searchFilters = { ...this.searchFilters, [key]: null }
    }
    this._applyAllFilters()
  }

  clearAllFilters () {
    this.filterText = null
    this.searchFilters = { attendant: null, invoiceSettlementType: null, period: null }
    this.datatableModelFilter = this.datatableModel
  }

  async actionButtonDetail (row) {
    this.modalDetailData = {
      show: true,
      id: row.id
    }
  }

  async mounted () {
    try {
      await Promise.all([
        this.load(),
        this.loadDatatable(),
        this.loadDatatableModel()
      ])
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.LOAD_ERROR}:`, {
        error,
        method: 'mounted',
        consumerUnit: this.consumerUnit,
        protocol: this.protocol,
        state: {
          hasData: !!this.data,
          hasDatatable: !!this.datatable,
          hasDatatableModel: !!this.datatableModel
        }
      })
    }
  }

  async load () {
    try {
      this.data =
        await this.serviceRequestInvoiceSettlementController.loadInvoiceSettlementConsumerUnit(
          this.consumerUnit
        )
      this.dataFilter = this.data
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.LOAD_ERROR}:`, {
        error,
        method: 'load',
        interface: INTERFACE_NAMES.LOAD_INVOICE_SETTLEMENT,
        consumerUnit: this.consumerUnit
      })
      throw error
    }
  }

  async loadDatatableModel () {
    try {
      this.datatableModel =
        await this.serviceRequestInvoiceSettlementController.loadDatatableModel(
          this.consumerUnit
        )
      this._applyAllFilters()
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.LOAD_DATATABLE_MODEL_ERROR}:`, {
        error,
        method: 'loadDatatableModel',
        interface: INTERFACE_NAMES.LOAD_DATATABLE_MODEL,
        consumerUnit: this.consumerUnit,
        currentModel: this.datatableModel
      })
      throw error
    }
  }

  async loadDatatable () {
    try {
      this.datatable =
        await this.serviceRequestInvoiceSettlementController.loadDatatable(
          this.consumerUnit
        )
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.LOAD_DATATABLE_ERROR}:`, {
        error,
        method: 'loadDatatable',
        interface: INTERFACE_NAMES.LOAD_DATATABLE,
        consumerUnit: this.consumerUnit,
        currentDatatable: this.datatable
      })
      throw error
    }
  }

  async actionButton (button, params) {
    return await {
      btExemption: () => this.btExemption(button.label),
      btCancellation: () => this.btCancellation(button.label),
      icDetalhar: () => this.icDetalhar(button, params),
      btPesquisar: () => this.btPesquisar(button, params)
    }[button.name]()
  }

  closeInvoiceSettlementModal () {
    this.exemptionModal.show = false
    this.cancellationModal.show = false
    this.loadDatatableModel()
  }

  btPesquisar (button, params) {
    this.searchModal = {
      show: true,
      label: button.label
    }
  }

  async btExemption (label) {
    this.exemptionModal = {
      show: true,
      label: `${label} (${this.consumerUnit})`
    }
  }

  async btCancellation (label) {
    this.cancellationModal = {
      show: true,
      label: `${label} (${this.consumerUnit})`
    }
  }

  get situationMapSettlement () {
    return situationMapSettlement
  }

  get settlementType () {
    return settlementTypeMap()
  }

  getSettlementTypeByCode (code) {
    if (code) {
      for (const settlement in this.settlementType) {
        if (
          Object.prototype.hasOwnProperty.call(this.settlementType, settlement)
        ) {
          const settlementKeys = this.settlementType[settlement].keys || []
          if (settlementKeys.includes(code)) {
            return this.settlementType[settlement]
          }
        }
      }
    }
    return { text: code, color: '#fff' }
  }

  getSituatinByKey (key) {
    if (key) {
      for (const situation in this.situationMapSettlement) {
        if (
          Object.prototype.hasOwnProperty.call(this.situationMapSettlement, situation)
        ) {
          const situationKeys = this.situationMapSettlement[situation].keys || []
          if (situationKeys.includes(key.toString())) {
            return this.situationMapSettlement[situation]
          }
        }
      }
    }
    return { text: key, color: '#fff' }
  }

  async icDetalhar (button, params) {
    try {
      const forms = await this.serviceRequestInvoiceSettlementController.detail(
        button.action,
        params
      )

      this.modalData = {
        show: true,
        forms,
        label: button.label,
        params,
        detail: true
      }
    } catch (error) {
      console.error(`${this.ERROR_MESSAGES.DETAIL_ERROR}:`, {
        error,
        method: 'icDetalhar',
        interface: INTERFACE_NAMES.DETAIL,
        button,
        params,
        consumerUnit: this.consumerUnit
      })
      throw error
    }
  }
}

export default ServiceRequestInvoiceSettlement
</script>

<style lang="stylus" scoped>
.btn-title {
    font-weight: 500;
}

.btn-dropdown {
    margin: 0;
}
.table-header
  text-align: center !important

.text-center
  text-align: center !important

.width-5
  width: 5px

.text-color
  color: #333

.font-size-field
  font-size: 17px

.font-size-date
  font-size: 14px

.width-1
  width: 1px

.nowrap
  white-space: nowrap

.buttons-row
  // Adicione aqui estilos específicos para a linha de botões, se necessário.
</style>
